import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { firstValueFrom } from 'rxjs'

import { Action, CountryCodes, Resource, UserProfile } from '@ti/contracts'
import { ApiService } from '@ti/core/api'
import { injectDestroy$, selectState } from '@ti/core/common/utils'
import { CONFIG } from '@ti/core/contracts/config'
import { UsersIconComponent } from '@ti/core/icons/users'
import { FleetHeaderComponent } from '@ti/core/ui-kit/layout/components/fleet-header'
import { UserFormMode, UsersGridComponent } from '@ti/shared/user'

import { AdminTspUsersModel, provideAdminTspUsersModel } from '../models/users.model'
import { AdminTspUserManager, provideAdminTspUserManager } from '../services/user.manager'

@Component({
  selector: 'app-ti-admin-users-page',
  templateUrl: 'users-page.component.html',
  styleUrls: ['users-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideAdminTspUsersModel(), provideAdminTspUserManager()],
  imports: [FleetHeaderComponent, AsyncPipe, UsersIconComponent, UsersGridComponent],
})
export class TSPUsersPageComponent {
  protected readonly api = inject(ApiService)
  protected readonly config = inject(CONFIG)
  protected readonly model = inject(AdminTspUsersModel)
  protected readonly userManager: AdminTspUserManager = inject(AdminTspUserManager)
  protected readonly state = selectState(AdminTspUsersModel)
  protected readonly destroy$ = injectDestroy$()

  protected readonly usernamePrefix = 'ti'
  protected readonly usersDisplayColumns = [
    'favourite',
    'user',
    'role',
    'tspName',
    'lastActivity',
    'loginAs',
  ]

  protected readonly Action = Action
  protected readonly Resource = Resource
  protected readonly TYPES = { CountryCodes, UserFormMode }

  async onFavouriteClick(user: UserProfile) {
    const favourite = !user.favourite
    user.favourite = favourite
    await firstValueFrom(this.userManager.toggleFavourite$(user, favourite))
    this.model.refresh()
  }
}
